// extracted by mini-css-extract-plugin
export var buttonContainer = "_15-6";
export var centeredToolbar = "_15-4";
export var dashdraw = "_15-c";
export var emptyStateContainer = "_15-8";
export var emptyStateText = "_15-9";
export var flowEditor = "_15-0";
export var flowEditorContainer = "_15-7";
export var hovered = "_15-1";
export var leftPanel = "_15-3";
export var mainCanvasContainer = "_15-a";
export var minimap = "_15-b";
export var selectMode = "_15-2";
export var toolbarSeparator = "_15-5";